import * as React from "react";
import { Alert, Typography } from "@mui/material";
import { brand } from "../theme";

export function SkippedQuestionBadge(props: { label: string }) {
  return (
    <Typography
      sx={{
        fontWeight: 900,
        fontSize: 11,
        letterSpacing: 0.6,
        color: brand.textSecondary,
        bgcolor: brand.surfaceSunken,
        border: `1px solid ${brand.border}`,
        borderRadius: 999,
        px: 1,
        py: 0.2,
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      {props.label}
    </Typography>
  );
}

export function SkippedQuestionNotice(props: {
  label: string;
  notice: string;
}) {
  return (
    <Alert
      severity="warning"
      sx={{
        mt: 1.5,
        borderRadius: 2,
        border: `1px solid ${brand.border}`,
        bgcolor: brand.surfaceMuted,
        color: brand.textSecondary,
        "& .MuiAlert-icon": {
          color: brand.accentStrong,
        },
      }}
    >
      <Typography sx={{ fontWeight: 900, mb: 0.25, color: brand.textPrimary }}>
        {props.label}
      </Typography>
      <Typography variant="body2" sx={{ color: brand.textSecondary }}>
        {props.notice}
      </Typography>
    </Alert>
  );
}

export const skipQuestionButtonSx = {
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 900,
  color: brand.textMuted,
  "&:hover": {
    bgcolor: brand.page,
    color: brand.textPrimary,
  },
} as const;
